import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { academySteps } from '../data/academySteps';
import { Sparkle } from '../components/Sparkle';
import { useSeo } from '../hooks/useSeo';
export function Ablauf() {
  useSeo({
    title: 'Ablauf der Academy | Hot Sales Girls Academy',
    description: 'Schritt für Schritt zum Erfolg: So läuft die Hot Sales Girls Academy ab – von den Grundlagen im Closing über wöchentliche Live-Trainings bis zur Begleitung in deinen Remote Job.',
    path: '/ablauf'
  });
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-409" data-mp="3crroivrn2dft">
      <div className="pink-panel relative" data-id="element-410" data-mp="3ctck8opow2f9">
        <div className="relative z-10" data-id="element-411" data-mp="2fcdwbiitfd5g">
          <Navbar data-id="element-412" data-mp="2fbm8wuzdglq9" />

          <main className="relative w-full bg-cream px-4 pb-14 pt-6 sm:px-6 sm:pb-20 sm:pt-8" data-id="element-413" data-mp="2fc42fjungluh">
            <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-414" data-mp="2k9w1cxtpp886" />
            <span aria-hidden="true" className="gold-glitter-extra" data-id="element-415" data-mp="vt7yrpoaj0ng" />
            <div className="relative z-10 mx-auto max-w-[1300px]" data-id="element-416" data-mp="rsxqg6d0zy5f">
              <header className="text-center" data-id="element-417" data-mp="ruse3sfom4d7">
                <span className="mb-6 block text-[11px] font-semibold uppercase tracking-[0.25em] text-hot-500" data-id="element-418" data-mp="n15zvvtvdsfa">
                  Schritt für Schritt
                </span>
                <div className="relative inline-block" data-id="element-419" data-mp="d3jjf4wx9st7">
                  <Sparkle className="animate-sparkle-delayed bottom-1 right-[3.75rem] h-8 w-8 sm:-right-8 sm:-top-4 sm:bottom-auto sm:h-10 sm:w-10 md:bottom-1 md:right-[28%] md:top-auto lg:-right-8 lg:-top-4 lg:bottom-auto" data-id="element-420" data-mp="d5co4enz62yk" />
                  <h1 className="font-heading mx-auto max-w-3xl text-3xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-5xl" data-id="element-421" data-mp="44y2fe73mluj">
                    Schritt für Schritt zum Erfolg
                  </h1>
                </div>
              </header>

              <ol className="mt-12 space-y-14 sm:mt-16 sm:space-y-20" data-id="element-422" data-mp="1tjclbhvfrei4">
                {academySteps.map((step, index) => <motion.li key={step.number} initial={{
                opacity: 0,
                y: 24
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                margin: '-80px'
              }} transition={{
                duration: 0.45
              }} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-423" data-mp="2ckjwumjk28fz" data-mpi={index}>
                    <div className={index % 2 === 1 ? 'order-1 text-center lg:order-2 lg:text-center' : 'order-1 text-center'} data-id="element-424" data-mp="2wbf8nul9kke2">
                      <span className="font-numeral text-gold-3d text-gold-3d-single block pb-2 text-6xl font-black sm:text-7xl" data-id="element-425" data-mp="2ra9avicqy6xo">
                        {step.number}
                      </span>
                      <h2 className="font-heading mx-auto mt-6 max-w-md text-2xl font-bold leading-tight text-neutral-900 sm:text-3xl" data-id="element-426" data-mp="1fx6v2pih1lek">
                        {step.title}
                      </h2>
                      <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-neutral-600 sm:text-base" data-id="element-427" data-mp="13d04alws4wp2">
                        {step.text}
                      </p>
                    </div>

                    <img src={step.image} alt={step.imageAlt} className={`mx-auto w-full max-w-md rounded-3xl object-contain shadow-2xl ${index % 2 === 1 ? 'order-2 lg:order-1' : 'order-2'}`} data-id="element-428" data-mp="1cfri2sd4o4jv" />
                  </motion.li>)}
              </ol>
            </div>
          </main>

          <Footer data-id="element-429" data-mp="tlvpbm73tbu8" />
        </div>
      </div>
      <CookieBanner data-id="element-430" data-mp="5xvy6l5vrjf4" />
    </div>;
}